import Layout from "@components/Layout"
import RadioInputButton from "@components/RadioInputButton"
import { useTranslation } from "react-i18next"
import { Form, useSubmit } from "react-router-dom"

export default function TakingBreaksPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    submit(event.currentTarget.form)
  }

  return (
    <Layout>
      <div className="shrink-0">
        <h1 className="custom-heading">
          {t("pages.onboardingV2.takingBreaks.heading")}
        </h1>
      </div>

      <Form className="flex grow flex-col justify-center gap-5" method="post">
        <RadioInputButton
          className="from-pd-green"
          emoji="🌿"
          label={t("pages.onboardingV2.takingBreaks.yes")}
          name={t("pages.onboardingV2.takingBreaks.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.takingBreaks.yes", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-yellow"
          emoji="😌"
          label={t("pages.onboardingV2.takingBreaks.sometimes")}
          name={t("pages.onboardingV2.takingBreaks.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.takingBreaks.sometimes", {
            lng: "en",
          })}
        />

        <RadioInputButton
          className="from-pd-orange"
          emoji="😬"
          label={t("pages.onboardingV2.takingBreaks.no")}
          name={t("pages.onboardingV2.takingBreaks.heading", {
            lng: "en",
          })}
          onChange={handleChange}
          value={t("pages.onboardingV2.takingBreaks.no", {
            lng: "en",
          })}
        />
      </Form>
    </Layout>
  )
}
